const version = "3.4.1";
const publishDates = {
  major: "2024-09-13T14:36:29.063Z",
  minor: "2024-10-24T14:44:00.648Z",
  patch: "2024-11-04T14:53:50.127Z"
};
export {
  publishDates,
  version
};
//# sourceMappingURL=version.mjs.map
